<template>
  <div :class="classTable">
    <el-table
      style="width: 100%"
      ref="table"
      :data="filterItems"
      :border="board"
      :fit="fit"
      :stripe="stripe"
      :lazy="lazy"
      v-loading="isLoading || customLoading"
      v-bind="$attrs"
    >
      <el-table-column
        width="50"
        fixed
        align="center"
        v-if="actions !== undefined"
      >
        <template slot="header" slot-scope="scope">
          <i class="el-icon-setting" :key="scope.$index"></i>
        </template>
        <template slot-scope="scope">
          <el-dropdown trigger="click" @command="handleCommand">
            <span class="el-dropdown-link">
              <i class="mdi mdi-menu"></i>
            </span>
            <el-dropdown-menu slot="dropdown">
              <template v-for="(action, index) in actions">
                <el-dropdown-item
                  v-if="
                    action.condition !== undefined &&
                    typeof action.condition === 'function'
                      ? action.condition(scope.row)
                      : true
                  "
                  :key="index"
                  :command="{
                    index: scope.$index,
                    row: scope.row,
                    column: scope.column,
                    command: action.command,
                    condition:
                      action.condition !== undefined &&
                      typeof action.condition === 'function'
                        ? action.condition(scope.row)
                        : true
                  }"
                  :icon="action.icon"
                  >{{ action.label }}</el-dropdown-item
                >
              </template>
            </el-dropdown-menu>
          </el-dropdown>
        </template>
      </el-table-column>

      <el-table-column
        v-for="(column, index) in columns"
        :key="index"
        :prop="column.prop"
        :label="column.name"
        :width="column.width"
        :min-width="column.minWidth"
        :sortable="column.sortable"
        :resizable="column.resizable"
        :formatter="
          typeof column.formatter === 'function' ? column.formatter : null
        "
        :fixed="column.fixed"
        :align="column.aling"
      >
        <template
          #default="{ row }"
          v-if="typeof column.formatter !== 'function'"
        >
          <div
            v-if="column.formatter"
            :is="column.formatter"
            v-bind="{
              row: row,
              column: column.prop,
              ...column.cellAtrrs,
              ...column.attrs
            }"
          ></div>
          <template v-else>
            {{ row[column.prop] }}
          </template>
        </template>
      </el-table-column>
    </el-table>

    <div style="margin: 10px">
      <el-pagination
        style="margin-top: 20px"
        :hide-on-single-page="hidePaginator"
        :current-page="pagination.currentPage"
        :page-size="pagination.pageSize"
        :layout="pageLayout"
        :total="pagination.total"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      />
    </div>
  </div>
</template>
<script>
import { createNamespacedHelpers } from "vuex";

const { mapState, mapGetters, mapActions, mapMutations } =
  createNamespacedHelpers("rabbey_table");

export default {
  name: "RabbeyTable2",
  props: {
    /* Lista pasada como resultado de una busqueda custom a la API */
    filterList: {
      type: Array,
      default: () => [],
      required: false
    },
    /** Parametro de busqueda en la data de la tabla. */
    search: {
      type: String,
      default: "",
      required: false
    },
    keySearch: {
      type: String,
      default: "Name",
      required: false
    },
    /** Configuracion del layout del paginador. */
    pageLayout: {
      type: String,
      default: "total, sizes, prev, pager, next, jumper",
      required: false
    },
    /**
     * Configuration of the columns of the table.
     *
     * Example: columns = [{label: "Label", prop: "Id", width: 80}]
     */
    columns: {
      type: Array,
      required: true
    },
    /**
     * Configuration of table actions.
     *
     * Example: actions = [{icon: "el-icon-view", label: "View", command: "vuew"}]
     */
    actions: {
      type: Array,
      required: false
    },
    /**
     * Indicates if the table will have borders, by default it is true
     * following the table standard.
     */
    board: {
      type: Boolean,
      default: true
    },
    /**
     * The auto table adjusts the width of the columns.
     */
    fit: {
      type: Boolean,
      default: true
    },
    /**
     * Indicates if the table will have stripes.
     */
    stripe: {
      type: Boolean,
      default: true
    },
    /**
     * Indicates heavy load.
     */
    lazy: {
      type: Boolean,
      default: true
    },
    /**
     * Css classes for the table container.
     */
    classTable: {
      type: Object,
      default() {
        return {
          "table-box": true,
          "card-base": true,
          "card-shadow--medium": true
        };
      }
    },
    /**
     * Esto sirve para pasar los items sin tener que usar el getData.
     * Esto cubre
     */
    defaultItems: {
      type: Array,
      required: false
    },
    /**
     * Un objecto que sera pasado a la peticion realizada para buscar los
     * items como params.
     */
    defaultParams: {
      type: Object,
      required: false
    },
    /**
     * La url a usar para la consulta de items.
     */
    indexUrl: {
      type: String,
      required: false,
      default: ""
    },
    customLoading: {
      type: Boolean,
      default: false
    },
    paginateFromApi: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      refreshParams: {}
    };
  },
  created() {
    if (this.indexUrl.length > 0 || this.indexUrl !== undefined) {
      this.setUrl(this.indexUrl);
    }
  },
  mounted() {
    this.initialTable();
  },
  computed: {
    ...mapState(["pagination", "items", "url", "originalItems"]),
    ...mapGetters(["isLoading"]),
    hidePaginator() {
      return this.pagination.total <= 10;
    },
    filterItems() {
      //console.log("Computed filter items");

      if (this.filterList.length > 0) {
        this.$emit("EmployeeData", this.filterList);
        return this.filterList;
      }

      let result = [];

      if (
        this.search === null ||
        this.search.length === 0 ||
        typeof this.search !== "string"
      ) {
        result = this.items;
      } else {
        if (this.filterList.length > 0) {
          result = this.filterList;
        } else {
          result = this.originalItems.filter((data) => {
            const value = data[this.keySearch];
            const valueType = typeof value;

            if (valueType === "number") {
              return value.toString() === this.search;
            }

            return (
              !this.search ||
              data[this.keySearch]
                .toLowerCase()
                .includes(this.search.toLowerCase())
            );
          });
        }
      }
      this.$emit("EmployeeData", result);
      return result;
    },
    params() {
      return this.defaultParams !== undefined
        ? { ...this.defaultParams, ...this.refreshParams }
        : {};
    }
  },
  methods: {
    ...mapActions(["getItems", "paginate", "resetCurrent"]),
    ...mapMutations({
      setItems: "items",
      setOriginalItems: "originalItems",
      setLoading: "loading",
      setSuccess: "success",
      setUrl: "url"
    }),
    refreshTable() {
      this.initialTable();
    },
    initialTable() {
      if (
        !this.paginateFromApi &&
        (this.indexUrl !== null || this.indexUrl !== undefined)
      ) {
        this.getItems({
          params: this.params,
          url: this.indexUrl,
          paginateFromApi: false
        });
        return true;
      }

      if (this.paginateFromApi) {
        this.getItems({
          params: this.params,
          url: this.indexUrl,
          paginateFromApi: true
        });
        return true;
      }

      this.setItems(this.defaultItems);
      this.setOriginalItems(this.defaultItems);
      this.__paginate();
      return true;
    },
    /**
     * Reference to the table
     */
    table() {
      return this.$refs.table;
    },
    /**
     * Captura el evento de cambio de size de la pagina de tabla.
     *
     * @param {Number} val : Numero de items por pagina.
     */
    handleSizeChange(val) {
      this.__paginate({ page_size: val });
    },
    /**
     * Captura el evento de cambio de pagina de la tabla.
     *
     * @param {Number} val : Numero de la pagina a navegar.
     */
    handleCurrentChange(val) {
      this.__paginate({ current_page: val });
    },
    /**
     * This method listens for the command event in the dropdown
     * from table actions
     * @param {Object} command : object with the data of the row invoked
     */
    handleCommand(command) {
      return this.$emit("rtable-push-action", command);
    },
    /**
     * Metodo privado, usado por los handle del paginador.
     */
    __paginate(payload = {}) {
      if (this.url !== undefined && this.paginateFromApi === true) {
        this.getItems({
          params: this.params,
          paginateFromApi: this.paginateFromApi,
          ...payload
        });
        return;
      }

      if (
        this.url === undefined ||
        this.paginateFromApi === false ||
        (this.url === undefined && this.paginateFromApi === false)
      ) {
        this.paginate(payload);
        return;
      }
    }
  },
  watch: {
    defaultItems(val) {
      this.setItems(val);
      this.setOriginalItems(val);
      this.__paginate();
    },
    defaultParams() {
      this.refreshTable();
    }
  }
};
</script>
